<template>
  <div class="header-section">
    <h3 v-if="data.OrderDate" class="muted pull-right">
      Ordered {{ formatDate(data.OrderDate) }}
    </h3>
     <h1>Order #{{ data.OrderNumber }}</h1>
     <h2 v-if="data.isPartsFastPartsFree">Parts Fast Parts Free (PFPF) Requested</h2>
    <b-row>
      <b-col xs="12" sm="6">
        <div class="detail-section">
          <h2>{{ getContentItem("billTo") }}</h2>
        </div>
        <p class="detail-address">
          <postal-address :address="data.BillingAddress" />
        </p>
      </b-col>
      <b-col xs="12" sm="6">
        <div class="detail-section">
          <h2>{{ getContentItem("shipTo") }}</h2>
        </div>
        <p class="detail-address">
          <postal-address :address="data.ShippingAddress" />
        </p>
      </b-col>
    </b-row>
    <b-row v-if="data.FinalToAddress">
      <b-col xs="12">
        <div class="detail-section">
          <h2>{{ getContentItem("finalTo") }}</h2>
        </div>
        <p class="detail-address">
          <postal-address :address="data.FinalToAddress" />
        </p>
      </b-col>
    </b-row>
    <b-row v-if="data.Comments">
      <b-col xs="12">
        <div class="detail-section">
          {{ getContentItem("comments") }}
        </div>
        <p>{{ data.Comments }}</p>
      </b-col>
    </b-row>
    <div class="detail-section">
      <h2>{{ getContentItem("OrderDetails") }}</h2>
    </div>
    <mcf-header-details v-if="data.isMcfOrder" :data="headerDetail()" />
    <rpi-header-details v-if="data.isRpiOrder" :data="headerDetail()" />
  </div>
</template>

<script>
  import moment from "moment";

  import { mapGetters } from "vuex";

  import { PostalAddress } from "@/components/Elements";

  import McfHeaderDetails from "./McfHeaderDetails";
  import RpiHeaderDetails from "./RpiHeaderDetails";

  export default {
    name: "OrderDetailsHeader",
    components: {
      PostalAddress,
      McfHeaderDetails,
      RpiHeaderDetails
    },
    computed: {
      ...mapGetters(["getContentItem"])
    },
    props: {
      data: Object
    },
    methods: {
      formatDate: function(value) {
        return moment(value).format("MMM D, YYYY");
      },

      headerDetail: function() {
        return {
          ...this.data,
          shipViaHtml: this.getShipViasHtml(),
          orderedByHtml: this.getOrderedByHtml()
        };
      },

      getShipViasHtml: function() {
        return this.data.ShipVias
          ? this.data.ShipVias.map(
            x => `${x.WarehouseName}: ${x.ShippingCarrierName}`
          ).join("<br />")
          : "";
      },

      getOrderedByHtml: function() {
        if (!this.data.OrderedBy || !this.data.OrderedBy.FullName) {
          return "";
        }

        return this.data.OrderedBy.Email
          ? `<a href="mailto:${this.data.OrderedBy.Email}">${this.data.OrderedBy.FullName}</a>`
          : this.data.OrderedBy.FullName;
      }
    }
  };
</script>
